import { call, put } from 'redux-saga/effects';
import {
  fetchUploadedFileTransactionsFailure,
  fetchUploadedFileTransactionsSuccess,
} from '../actions';
import { getUploadedFileTransactions } from '../api';
import { FetchUploadedFileTransactionsRequestAction } from '../types';
import type { ValidatedExcelTransaction } from '../models';
import type { ExcelTransaction } from '../models';
import { normalizeExcelTransactionFromApi } from '../reducer/excelHandlers';

function toValidatedTransaction(
  row: ExcelTransaction
): ValidatedExcelTransaction {
  return { ...normalizeExcelTransactionFromApi(row), errorReason: '' };
}

export function* fetchUploadedFileTransactionsSaga(
  action: FetchUploadedFileTransactionsRequestAction
) {
  try {
    const { organisationId, importId, page, pageSize } = action.payload;
    const response = yield call(
      getUploadedFileTransactions,
      organisationId,
      importId,
      page,
      pageSize
    );
    const files = response?.data?.files;
    const content: ExcelTransaction[] = files?.content ?? [];
    const total = files?.totalElements ?? 0;
    const transactions: ValidatedExcelTransaction[] = content.map(
      toValidatedTransaction
    );
    yield put(
      fetchUploadedFileTransactionsSuccess(
        transactions,
        total,
        page,
        files?.pageSize ?? pageSize
      )
    );
  } catch {
    yield put(fetchUploadedFileTransactionsFailure());
  }
}
